import { render } from "./Lp.vue?vue&type=template&id=925e39c0&scoped=true"
import script from "./Lp.vue?vue&type=script&lang=js"
export * from "./Lp.vue?vue&type=script&lang=js"

import "./Lp.vue?vue&type=style&index=0&id=925e39c0&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/changlei/roblox-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-925e39c0"]])

export default __exports__